// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link, useNavigate } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';

// import useGetPurchaseRequestList from '@hooks/PUR/PurchaseRequest/useGetPurchaseRequestList';
// import NeatixModal from '@components/Modal/NeatixModal';
// import SendToSuppliers from './SendToSuppliers';
// import NtxTable from '@components/DataTable/NtxTable';
// import { useAppDispatch } from '@store/hooks';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { DeletePurchaseRequest, getPurchaseRequestList } from '@store/purchases/PurchaseRequests/purchaseRequestsSlice';
// import { Can } from '@Permisstions/Can';

// const Index = () => {
//   const [show, setShow] = useState(false);

//   const [date, setDate] = useState('');
//   const [search, setSearch] = useState('');
//   const { t, i18n } = useTranslation();
//   const Navigate = useNavigate();

//   const { PurchaseRequestsList, loading, error } = useGetPurchaseRequestList();

//   const dispatch = useAppDispatch();

//   const handleDeletePurchaseOrder = async (id: string) => {
//     const isConfirmed = await confirmAction('هل أنت متأكد من حذف طلب الشراء؟');

//     if (!isConfirmed) return;

//     try {
//       const result = await dispatch(DeletePurchaseRequest(id)).unwrap();
//       if (result?.succeeded) {
//         CustomAlert({ action: 'Delete', msg: t('تم حذف أمر الشراء بنجاح') });
//         dispatch(getPurchaseRequestList());
//       }
//     } catch (e: any) {
//       CustomAlert({ action: 'Error', msg: e?.message || t('فشل حذف أمر الشراء') });
//     }
//   };

//   const filteredSearch = PurchaseRequestsList?.slice()
//     ?.filter(item => {
//       const searchLowerCase = search.toLowerCase();
//       return (
//         item.name?.toLowerCase().includes(searchLowerCase) ||
//         item.name2?.toLowerCase().toString().includes(searchLowerCase)
//       );
//     })
//     ?.filter(f => {
//       if (!date) return true; // إذا كانت قيمة التاريخ فارغة، اجلب جميع النتائج بدون تصفية
//       const itemDate = new Date(f.transactionDate).toDateString(); // تحويل التاريخ إلى كائن Date واستخراج اليوم
//       const selectedDate = new Date(date).toDateString(); // تحويل التاريخ المحدد إلى كائن Date واستخراج اليوم
//       return itemDate === selectedDate; // مقارنة اليوم فقط (بدون الوقت)
//     })
//     ?.sort((a, b) => b?.no - a?.no);

//   const columns = [
//     { title: t('PurchaseRequestNumber'), key: 'code' },
//     { title: t('PurchaseRequestDate'), key: 'date' },
//     { title: t('Branch'), key: 'branch' },
//     { title: t('Inventory'), key: 'inv' },
//     { title: t(''), key: 'action', className: 'text-end' }
//   ];

//   const tableData = filteredSearch?.map(item => {
//     let rowClass;

//     return {
//       code: item.code,
//       date: item.transactionDate?.toString()?.split('T')[0],
//       branch: i18n.language === 'en' ? item.organizationName : item.organizationName2,
//       inv: i18n.language === 'en' ? item.inventoryName : item.inventoryName2,
//       action: (
//         <>
//           <Can permission={'PURSendPurchaseRequestsToSuplaier'}>
//             <button type='button' className='btn btn-sm btn-outline-theme mx-1' onClick={() => setShow(true)}>
//               <i className='far fa-lg fa-fw me-2 fa-paper-plane'></i>
//               {t('SendToSuppliers')}
//             </button>
//           </Can>
//           <button
//             type='button'
//             className='btn btn-sm btn-outline-danger mx-1'
//             onClick={() => handleDeletePurchaseOrder(item.id)}
//           >
//             <i className='fas fa-trash fa-lg'></i>
//           </button>
//           <Can permission={'PURViewPurchaseRequestsDetails'}>
//             <>
//               <button
//                 type='button'
//                 className='btn btn-sm btn-outline-theme mx-1'
//                 onClick={() => Navigate(`${item.id}/UpdatePurchaseRequest`)}
//               >
//                 <i className='far fa-lg fa-fw fa-eye'></i>
//               </button>
//             </>
//           </Can>
//         </>
//       )
//     };
//   });

//   //____________________________

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },
//             {
//               name: 'PurchaseRequests',
//               link: null
//             }
//           ]}
//           PageName='PurchaseRequests'
//         />
//         <div className='ms-auto'>
//           <Can permission={'PURAddPurchaseRequests'}>
//             <Link to='AddPurchaseRequest' className='btn me-1 btn-theme'>
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('AddNewPurchaseRequest')}
//             </Link>
//           </Can>
//         </div>
//       </div>
//       <Card>
//         <Loading loading={loading} error={error} Type='Logo'>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal show={show} setShow={setShow} bodyClassName='p-1' size='lg' showHeader={false}>
//         <Card>
//           <SendToSuppliers />
//         </Card>
//       </NeatixModal>
//     </div>
//   );
// };

// export default Index;

import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import SendToSuppliers from './SendToSuppliers';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters, setSortOrders } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
import { Can } from '@Permisstions/Can';
import Select from 'react-select';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import confirmAction from '@components/Shared/Alert/confirmAction';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { DeletePurchaseRequest } from '@store/purchases/PurchaseRequests/purchaseRequestsSlice';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

const TABLE_KEY = 'PurchaseRequests_Index';

const Index = () => {
  const [showSendToSuppliers, setShowSendToSuppliers] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState<string | null>(null);

  // ✅ حالة الفلاتر الجديدة
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [inventoryFilter, setInventoryFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [searchFilter, setSearchFilter] = useState('');

  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  const { t, i18n } = useTranslation();
  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers } = useGetSuppliersList();
  const { InventoryOptions } = useGetInventoryWithPermission();

  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'PurchaseRequest/GetList_paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  // ✅ حساب عدد الفلاتر النشطة
  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ✅ دالة لإنشاء ID فريد للفلتر
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // ✅ دالة تطبيق الفلاتر
  const applyFilters = () => {
    const newFilters: any[] = [];

    // ✅ فلترة حسب المورد
    if (supplierFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'peopleId',
        operator: 0, // OpEquals
        value: supplierFilter.value
      });
    }

    // ✅ فلترة حسب وحدة التشغيل
    if (organizationFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'organizationId',
        operator: 0, // OpEquals
        value: organizationFilter.value
      });
    }

    // ✅ فلترة حسب المخزن
    if (inventoryFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'inventoryId',
        operator: 0, // OpEquals
        value: inventoryFilter.value
      });
    }

    // ✅ فلترة حسب التاريخ من
    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 3, // OpGreaterOrEqual
        value: dateFrom
      });
    }

    // ✅ فلترة حسب التاريخ إلى
    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 5, // OpLessOrEqual
        value: dateTo
      });
    }

    // ✅ فلترة حسب البحث (رقم الطلب أو الاسم)
    if (searchFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'code',
        operator: 7, // OpContains
        value: searchFilter
      });
    }

    // ✅ تطبيق الفلاتر عبر setFilters
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ دالة مسح جميع الفلاتر
  const clearFilters = (): void => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setInventoryFilter(null);
    setDateFrom('');
    setDateTo('');
    setSearchFilter('');

    // ✅ مسح جميع الفلاتر من الـ store
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ دالة مسح فلتر واحد
  const removeFilter = (fieldName: string) => {
    const currentFilters = filters || [];
    const filtered = currentFilters.filter((filter: any) => filter.field !== fieldName);

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: filtered }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));

    // ✅ تحديث الحقول المحلية
    if (fieldName === 'peopleId') {
      setSupplierFilter(null);
    } else if (fieldName === 'organizationId') {
      setOrganizationFilter(null);
    } else if (fieldName === 'inventoryId') {
      setInventoryFilter(null);
    } else if (fieldName === 'transactionDate') {
      setDateFrom('');
      setDateTo('');
    } else if (fieldName === 'code') {
      setSearchFilter('');
    }
  };

  const handleDeletePurchaseOrder = async (id: string) => {
    const isConfirmed = await confirmAction('هل أنت متأكد من حذف طلب الشراء؟');

    if (!isConfirmed) return;

    try {
      const result = await dispatch(DeletePurchaseRequest(id)).unwrap();
      if (result?.succeeded) {
        CustomAlert({ action: 'Delete', msg: t('تم حذف أمر الشراء بنجاح') });
        dispatch(getPagedData({ tableKey: TABLE_KEY }));
      }
    } catch (e: any) {
      CustomAlert({ action: 'Error', msg: e?.message || t('فشل حذف أمر الشراء') });
    }
  };

  const handleSendToSupplier = (id: string) => {
    setSelectedRequestId(id);
    setShowSendToSuppliers(true);
  };

  const displayData = data;

  const getInventoryTypeBadge = (item: any) => {
    if (item.noneInventoryFlag) {
      return (
        <span className='badge bg-info'>
          <i className='fas fa-boxes me-1'></i>
          {t('NonInventory')}
        </span>
      );
    }
    return (
      <span className='badge bg-success'>
        <i className='fas fa-warehouse me-1'></i>
        {t('Inventory')}
      </span>
    );
  };

  const fields: any = [
    { name: 'code', label: t('PurchaseRequestNumber'), type: 'string' },
    { name: 'transactionDate', label: t('PurchaseRequestDate'), type: 'date' },
    { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
    { name: 'organizationId', label: t('Branch'), type: 'options', options: OperatingUnitOptions },
    { name: 'inventoryId', label: t('Inventory'), type: 'options', options: InventoryOptions }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('PurchaseRequests'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PurchaseRequests')} />

        <div className='ms-auto'>
          <Can permission={'PURAddPurchaseRequests'}>
            <Link to='AddPurchaseRequest' className='btn btn-theme'>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddNewPurchaseRequest')}
            </Link>
          </Can>
        </div>
      </div>

      <Card className='mb-3 shadow bg-body1'>
        <CardHeader>
          <div className='row g-2 '>
            {/* ✅ فلترة بوحدة التشغيل */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة التشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالمخزن */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-warehouse'></i>
                </span>
                <Select
                  value={inventoryFilter}
                  onChange={setInventoryFilter}
                  options={InventoryOptions}
                  placeholder={t('اختر مخزن')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>
            {/* ✅ التاريخ من وإلى */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('From')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('To')}
                />
              </div>
            </div>

            {/* ✅ أزرار التطبيق والمسح */}
            <div className='col-lg-2 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>
              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={
                  !supplierFilter && !organizationFilter && !inventoryFilter && !dateFrom && !dateTo && !searchFilter
                }
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>
              <button
                className='btn btn-outline-theme w-md-auto'
                onClick={() => setShowFilters(true)}
                title={t('AdvancedFilters')}
              >
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>
      </Card>

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>{t('PurchaseRequestNumber')}</th>
                  <th className='small'>{t('PurchaseRequestDate')}</th>
                  <th className='small'>{t('Branch')}</th>
                  <th className='small'>{t('Inventory')}</th>
                  {/* <th className='small text-center'>{t('Type')}</th>
                  <th className='small'>{t('Supplier')}</th>
                  <th className='small'>{t('Amount')}</th> */}
                  <th className='small text-center'>{t('Actions')}</th>
                </tr>
              </thead>
              <tbody>
                {displayData.length > 0 ? (
                  displayData.map((item: any) => (
                    <tr key={item.id}>
                      <td className='align-middle'>
                        <strong className='text-theme'>{item.code}</strong>
                      </td>

                      <td className='align-middle'>{item.transactionDate?.split('T')[0]}</td>

                      <td className='align-middle'>
                        {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                      </td>

                      <td className='align-middle'>
                        {i18n.language === 'en' ? item.inventoryName : item.inventoryName2}
                      </td>

                      {/* <td className='align-middle text-center'>{getInventoryTypeBadge(item)}</td> */}

                      {/* <td className='align-middle'>
                        {item.peopleName ? (
                          <div className='d-flex flex-column'>
                            <strong className='fw-bold'>
                              {i18n.language === 'en' ? item.peopleName : item.peopleName2}
                            </strong>
                            {item.peopleCode && (
                              <small className='text-muted'>
                                {t('Code')}: {item.peopleCode}
                              </small>
                            )}
                          </div>
                        ) : (
                          <span className='text-muted'>{t('NotAssigned')}</span>
                        )}
                      </td> */}

                      {/* <td className='align-middle'>
                        <span className='fw-bold text-theme'>
                          {new Intl.NumberFormat(i18n.language, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }).format(item.netAmount || 0)}
                        </span>
                      </td> */}

                      <td className='align-middle'>
                        <div className='d-flex justify-content-end gap-2'>
                          <Can permission={'PURViewPurchaseRequestsDetails'}>
                            <Link
                              to={`${item.id}/UpdatePurchaseRequest`}
                              className='btn btn-sm btn-outline-theme'
                              title={t('ViewDetails')}
                            >
                              <i className='bi bi-info-circle fa-lg me-2'></i>
                              {t('ViewDetails')}
                            </Link>
                          </Can>

                          <Can permission={'PURSendPurchaseRequestsToSuplaier'}>
                            <button
                              type='button'
                              className='btn btn-sm btn-outline-theme mx-1'
                              onClick={() => handleSendToSupplier(item.id)}
                              title={t('SendToSuppliers')}
                            >
                              <i className='far fa-lg fa-fw me-2 fa-paper-plane'></i>
                              {t('Send')}
                            </button>
                          </Can>

                          <button
                            type='button'
                            className='btn btn-sm btn-outline-danger'
                            onClick={() => handleDeletePurchaseOrder(item.id)}
                            title={t('Delete')}
                          >
                            <i className='fas fa-trash fa-lg'></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoPurchaseRequests')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <NeatixModal
        show={showSendToSuppliers}
        setShow={setShowSendToSuppliers}
        bodyClassName='p-0'
        size='lg'
        showHeader={false}
      >
        {selectedRequestId && <SendToSuppliers  />}
      </NeatixModal>
    </>
  );
};

export default Index;
